import React, { useMemo, useCallback } from 'react';
import './SettingsModal.css';

const SettingsModal = ({ show, onClose, settings, setSettings, t }) => {

    const lang = settings.sourceLang || 'ko';

    const createOptions = useCallback((optionKey) => {
            const optionsObject = t(optionKey);
            if (!optionsObject || typeof optionsObject !== 'object') return [];

            return Object.keys(optionsObject).map(key => ({
                value: key,
                label: optionsObject[key][lang] || key
            }));
        }, [t, lang]);

    const relationshipOptions = useMemo(() => createOptions('settings.relationshipOptions'), [createOptions]);
    const toneOptions = useMemo(() => createOptions('settings.toneOptions'), [createOptions]);
    const regionOptions = useMemo(() => createOptions('settings.regionOptions'), [createOptions]);
    const styleOptions = useMemo(() => createOptions('settings.styleOptions'), [createOptions]);

    if (!show) {
        return null;
    }

    const handleSettingChange = (e) => {
        const { name, value } = e.target;
        setSettings(prevSettings => ({
            ...prevSettings,
            [name]: value
        }));
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="settings-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="settings-modal-title">{t('settings.title')}</h2>

                <div className="settings-form">
                    {/* Speaker */}
                    <div className="form-group">
                        <label htmlFor="speaker">{t('settings.speakerLabel')}</label>
                        <select
                            id="speaker"
                            name="speaker"
                            value={settings.speaker}
                            onChange={handleSettingChange}
                            className="settings-select"
                        >
                            {relationshipOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Listener */}
                    <div className="form-group">
                        <label htmlFor="listener">{t('settings.listenerLabel')}</label>
                        <select
                            id="listener"
                            name="listener"
                            value={settings.listener}
                            onChange={handleSettingChange}
                            className="settings-select"
                        >
                            {relationshipOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Tone */}
                    <div className="form-group">
                        <label htmlFor="tone">{t('settings.toneLabel')}</label>
                        <select
                            id="tone"
                            name="tone"
                            value={settings.tone}
                            onChange={handleSettingChange}
                            className="settings-select"
                        >
                            {toneOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Region/Dialect */}
                    <div className="form-group">
                        <label htmlFor="dialect">{t('settings.regionLabel')}</label>
                        <select
                            id="dialect"
                            name="dialect"
                            value={settings.dialect}
                            onChange={handleSettingChange}
                            className="settings-select"
                        >
                            {regionOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Style */}
                    <div className="form-group">
                        <label htmlFor="style">{t('settings.styleLabel')}</label>
                        <select
                            id="style"
                            name="style"
                            value={settings.style}
                            onChange={handleSettingChange}
                            className="settings-select"
                        >
                            {styleOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="settings-close-btn-container">
                    <button onClick={onClose} className="settings-complete-btn">{t('buttons.settingsComplete')}</button>
                </div>
            </div>
        </div>
    );
};

export default SettingsModal;
